module.exports = __webpack_public_path__ + "static/img/unfold_item2.441cbd21.png";